import {
  Companion_getInstance12sgbyys5mml7 as Companion_getInstance,
  Incident3aojs8cp7629c as Incident,
} from './databaseModels.mjs';
import {
  properties1qnxlk10mmfrs as properties,
  get_serializableAnnotations132wwdaanmitj as get_serializableAnnotations,
  SerializableProperty3ugfzrmvjw266 as SerializableProperty,
} from '../../../lightning-server-shared/com/lightningkite/serialization/SerializableProperty.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer } from '../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { lazy2hsh8ze7j6ikd as lazy } from '../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import { KProperty1ca4yb4wlo496 as KProperty1 } from '../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  UUID21wrnrlmk5y1y as UUID,
  Companion_getInstance3n9as6ds1py67 as Companion_getInstance_0,
} from '../../../lightning-server-shared/com/lightningkite/UUID.js.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import {
  IncidentState_Filed_getInstanceg9puzn4wq1pv as IncidentState_Filed_getInstance,
  IncidentState1cmotpowj6osp as IncidentState,
} from './enums.mjs';
import {
  AccessInfoj60d6hx1qs8r as AccessInfo,
  Issue1fn0d1tovjb9y as Issue,
} from './supportModels.mjs';
import { emptySetcxexqki71qfa as emptySet } from '../../../kotlin-kotlin-stdlib/kotlin/collections/Sets.mjs';
import { KtSetjrjc7fhfd6b9 as KtSet } from '../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import {
  ClientConcern_Other_getInstancezoo09lwnn20e as ClientConcern_Other_getInstance,
  ClientConcern1skfmbxl86a3t as ClientConcern,
} from './incidentResponse/IncidentResponseType.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_project(_this__u8e3s4) {
  return _this__u8e3s4.prop(Incident_project_getInstance());
}
function get_state(_this__u8e3s4) {
  return _this__u8e3s4.prop(Incident_state_getInstance());
}
function prepareIncidentFields() {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var props = [Incident__id_getInstance(), Incident_project_getInstance(), Incident_filed_getInstance(), Incident_issue_getInstance(), Incident_resolved_getInstance(), Incident_readBy_getInstance(), Incident_concern_getInstance(), Incident_state_getInstance(), Incident_canFileDispute_getInstance(), Incident_canLockProject_getInstance()];
  var tmp = Companion_getInstance().k2a();
  properties(tmp, (it) => props);
}
function Incident_project$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(1);
}
function Incident_project$_get_name_$ref_5uhmhl() {
  return (p0) => p0.i20();
}
function Incident_project$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[1];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function Incident_project$_get_serializer_$ref_h2z0jk() {
  return (p0) => p0.h2j();
}
function Incident_project$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(1);
}
function Incident_project$_get_annotations_$ref_g8o0hw() {
  return (p0) => p0.bz();
}
var Incident_projectClass;
function Incident_project() {
  if (Incident_projectClass === VOID) {
    class $ {
      constructor() {
        Incident_project_instance = this;
        var tmp = this;
        tmp.x62_1 = lazy(Incident_project$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.y62_1 = lazy(Incident_project$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.z62_1 = lazy(Incident_project$annotations$delegate$lambda);
      }
      i20() {
        var tmp0 = this.x62_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, Incident_project$_get_name_$ref_5uhmhl(), null);
        return tmp0.f2();
      }
      a63(receiver) {
        return receiver.c63_1;
      }
      k2j(receiver) {
        return this.a63(receiver instanceof Incident() ? receiver : THROW_CCE());
      }
      l63(receiver, value) {
        return receiver.m63(VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof Incident() ? receiver : THROW_CCE();
        return this.l63(tmp, value instanceof UUID() ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.y62_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, Incident_project$_get_serializer_$ref_h2z0jk(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.z62_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, Incident_project$_get_annotations_$ref_g8o0hw(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'Incident_project', VOID, VOID, [SerializableProperty()]);
    Incident_projectClass = $;
  }
  return Incident_projectClass;
}
var Incident_project_instance;
function Incident_project_getInstance() {
  if (Incident_project_instance === VOID)
    new (Incident_project())();
  return Incident_project_instance;
}
function Incident_state$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(7);
}
function Incident_state$_get_name_$ref_k684vj() {
  return (p0) => p0.i20();
}
function Incident_state$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[7];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function Incident_state$_get_serializer_$ref_vhppvs() {
  return (p0) => p0.h2j();
}
function Incident_state$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(7);
}
function Incident_state$_get_annotations_$ref_ya4jt0() {
  return (p0) => p0.bz();
}
var Incident_stateClass;
function Incident_state() {
  if (Incident_stateClass === VOID) {
    class $ {
      constructor() {
        Incident_state_instance = this;
        var tmp = this;
        tmp.n63_1 = lazy(Incident_state$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.o63_1 = lazy(Incident_state$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.p63_1 = lazy(Incident_state$annotations$delegate$lambda);
        this.q63_1 = IncidentState_Filed_getInstance();
        this.r63_1 = 'IncidentState.Filed';
      }
      i20() {
        var tmp0 = this.n63_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, Incident_state$_get_name_$ref_k684vj(), null);
        return tmp0.f2();
      }
      a63(receiver) {
        return receiver.i63_1;
      }
      k2j(receiver) {
        return this.a63(receiver instanceof Incident() ? receiver : THROW_CCE());
      }
      s63(receiver, value) {
        return receiver.m63(VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof Incident() ? receiver : THROW_CCE();
        return this.s63(tmp, value instanceof IncidentState() ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.o63_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, Incident_state$_get_serializer_$ref_vhppvs(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.p63_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, Incident_state$_get_annotations_$ref_ya4jt0(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'Incident_state', VOID, VOID, [SerializableProperty()]);
    Incident_stateClass = $;
  }
  return Incident_stateClass;
}
var Incident_state_instance;
function Incident_state_getInstance() {
  if (Incident_state_instance === VOID)
    new (Incident_state())();
  return Incident_state_instance;
}
function Incident__id$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(0);
}
function Incident__id$_get_name_$ref_g5ga56() {
  return (p0) => p0.i20();
}
function Incident__id$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[0];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function Incident__id$_get_serializer_$ref_fyp2bl() {
  return (p0) => p0.h2j();
}
function Incident__id$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(0);
}
function Incident__id$_get_annotations_$ref_drhonv() {
  return (p0) => p0.bz();
}
var Incident__idClass;
function Incident__id() {
  if (Incident__idClass === VOID) {
    class $ {
      constructor() {
        Incident__id_instance = this;
        var tmp = this;
        tmp.t63_1 = lazy(Incident__id$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.u63_1 = lazy(Incident__id$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.v63_1 = lazy(Incident__id$annotations$delegate$lambda);
        this.w63_1 = Companion_getInstance_0().k2p();
        this.x63_1 = 'UUID.random()';
      }
      i20() {
        var tmp0 = this.t63_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, Incident__id$_get_name_$ref_g5ga56(), null);
        return tmp0.f2();
      }
      a63(receiver) {
        return receiver.b63_1;
      }
      k2j(receiver) {
        return this.a63(receiver instanceof Incident() ? receiver : THROW_CCE());
      }
      l63(receiver, value) {
        return receiver.m63(value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof Incident() ? receiver : THROW_CCE();
        return this.l63(tmp, value instanceof UUID() ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.u63_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, Incident__id$_get_serializer_$ref_fyp2bl(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.v63_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, Incident__id$_get_annotations_$ref_drhonv(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'Incident__id', VOID, VOID, [SerializableProperty()]);
    Incident__idClass = $;
  }
  return Incident__idClass;
}
var Incident__id_instance;
function Incident__id_getInstance() {
  if (Incident__id_instance === VOID)
    new (Incident__id())();
  return Incident__id_instance;
}
function Incident_filed$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(2);
}
function Incident_filed$_get_name_$ref_xvil1k() {
  return (p0) => p0.i20();
}
function Incident_filed$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[2];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function Incident_filed$_get_serializer_$ref_qmniun() {
  return (p0) => p0.h2j();
}
function Incident_filed$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(2);
}
function Incident_filed$_get_annotations_$ref_arecsz() {
  return (p0) => p0.bz();
}
var Incident_filedClass;
function Incident_filed() {
  if (Incident_filedClass === VOID) {
    class $ {
      constructor() {
        Incident_filed_instance = this;
        var tmp = this;
        tmp.y63_1 = lazy(Incident_filed$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.z63_1 = lazy(Incident_filed$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.a64_1 = lazy(Incident_filed$annotations$delegate$lambda);
      }
      i20() {
        var tmp0 = this.y63_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, Incident_filed$_get_name_$ref_xvil1k(), null);
        return tmp0.f2();
      }
      a63(receiver) {
        return receiver.d63_1;
      }
      k2j(receiver) {
        return this.a63(receiver instanceof Incident() ? receiver : THROW_CCE());
      }
      b64(receiver, value) {
        return receiver.m63(VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof Incident() ? receiver : THROW_CCE();
        return this.b64(tmp, value instanceof AccessInfo() ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.z63_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, Incident_filed$_get_serializer_$ref_qmniun(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.a64_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, Incident_filed$_get_annotations_$ref_arecsz(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'Incident_filed', VOID, VOID, [SerializableProperty()]);
    Incident_filedClass = $;
  }
  return Incident_filedClass;
}
var Incident_filed_instance;
function Incident_filed_getInstance() {
  if (Incident_filed_instance === VOID)
    new (Incident_filed())();
  return Incident_filed_instance;
}
function Incident_issue$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(3);
}
function Incident_issue$_get_name_$ref_umdfa1() {
  return (p0) => p0.i20();
}
function Incident_issue$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[3];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function Incident_issue$_get_serializer_$ref_9ocwe8() {
  return (p0) => p0.h2j();
}
function Incident_issue$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(3);
}
function Incident_issue$_get_annotations_$ref_vycqv0() {
  return (p0) => p0.bz();
}
var Incident_issueClass;
function Incident_issue() {
  if (Incident_issueClass === VOID) {
    class $ {
      constructor() {
        Incident_issue_instance = this;
        var tmp = this;
        tmp.c64_1 = lazy(Incident_issue$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.d64_1 = lazy(Incident_issue$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.e64_1 = lazy(Incident_issue$annotations$delegate$lambda);
        this.f64_1 = null;
        this.g64_1 = 'null';
      }
      i20() {
        var tmp0 = this.c64_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, Incident_issue$_get_name_$ref_umdfa1(), null);
        return tmp0.f2();
      }
      a63(receiver) {
        return receiver.e63_1;
      }
      k2j(receiver) {
        return this.a63(receiver instanceof Incident() ? receiver : THROW_CCE());
      }
      h64(receiver, value) {
        return receiver.m63(VOID, VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof Incident() ? receiver : THROW_CCE();
        return this.h64(tmp, (value == null ? true : value instanceof Issue()) ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.d64_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, Incident_issue$_get_serializer_$ref_9ocwe8(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.e64_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, Incident_issue$_get_annotations_$ref_vycqv0(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'Incident_issue', VOID, VOID, [SerializableProperty()]);
    Incident_issueClass = $;
  }
  return Incident_issueClass;
}
var Incident_issue_instance;
function Incident_issue_getInstance() {
  if (Incident_issue_instance === VOID)
    new (Incident_issue())();
  return Incident_issue_instance;
}
function Incident_resolved$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(4);
}
function Incident_resolved$_get_name_$ref_lsvn6a() {
  return (p0) => p0.i20();
}
function Incident_resolved$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[4];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function Incident_resolved$_get_serializer_$ref_orpiux() {
  return (p0) => p0.h2j();
}
function Incident_resolved$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(4);
}
function Incident_resolved$_get_annotations_$ref_2mfper() {
  return (p0) => p0.bz();
}
var Incident_resolvedClass;
function Incident_resolved() {
  if (Incident_resolvedClass === VOID) {
    class $ {
      constructor() {
        Incident_resolved_instance = this;
        var tmp = this;
        tmp.i64_1 = lazy(Incident_resolved$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.j64_1 = lazy(Incident_resolved$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.k64_1 = lazy(Incident_resolved$annotations$delegate$lambda);
        this.l64_1 = null;
        this.m64_1 = 'null';
      }
      i20() {
        var tmp0 = this.i64_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, Incident_resolved$_get_name_$ref_lsvn6a(), null);
        return tmp0.f2();
      }
      a63(receiver) {
        return receiver.f63_1;
      }
      k2j(receiver) {
        return this.a63(receiver instanceof Incident() ? receiver : THROW_CCE());
      }
      n64(receiver, value) {
        return receiver.m63(VOID, VOID, VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof Incident() ? receiver : THROW_CCE();
        return this.n64(tmp, (value == null ? true : value instanceof AccessInfo()) ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.j64_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, Incident_resolved$_get_serializer_$ref_orpiux(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.k64_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, Incident_resolved$_get_annotations_$ref_2mfper(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'Incident_resolved', VOID, VOID, [SerializableProperty()]);
    Incident_resolvedClass = $;
  }
  return Incident_resolvedClass;
}
var Incident_resolved_instance;
function Incident_resolved_getInstance() {
  if (Incident_resolved_instance === VOID)
    new (Incident_resolved())();
  return Incident_resolved_instance;
}
function Incident_readBy$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(5);
}
function Incident_readBy$_get_name_$ref_o16n47() {
  return (p0) => p0.i20();
}
function Incident_readBy$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[5];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function Incident_readBy$_get_serializer_$ref_hky3qm() {
  return (p0) => p0.h2j();
}
function Incident_readBy$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(5);
}
function Incident_readBy$_get_annotations_$ref_73u5de() {
  return (p0) => p0.bz();
}
var Incident_readByClass;
function Incident_readBy() {
  if (Incident_readByClass === VOID) {
    class $ {
      constructor() {
        Incident_readBy_instance = this;
        var tmp = this;
        tmp.o64_1 = lazy(Incident_readBy$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.p64_1 = lazy(Incident_readBy$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.q64_1 = lazy(Incident_readBy$annotations$delegate$lambda);
        this.r64_1 = emptySet();
        this.s64_1 = 'emptySet()';
      }
      i20() {
        var tmp0 = this.o64_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, Incident_readBy$_get_name_$ref_o16n47(), null);
        return tmp0.f2();
      }
      a63(receiver) {
        return receiver.g63_1;
      }
      k2j(receiver) {
        return this.a63(receiver instanceof Incident() ? receiver : THROW_CCE());
      }
      t64(receiver, value) {
        return receiver.m63(VOID, VOID, VOID, VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof Incident() ? receiver : THROW_CCE();
        return this.t64(tmp, (!(value == null) ? isInterface(value, KtSet()) : false) ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.p64_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, Incident_readBy$_get_serializer_$ref_hky3qm(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.q64_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, Incident_readBy$_get_annotations_$ref_73u5de(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'Incident_readBy', VOID, VOID, [SerializableProperty()]);
    Incident_readByClass = $;
  }
  return Incident_readByClass;
}
var Incident_readBy_instance;
function Incident_readBy_getInstance() {
  if (Incident_readBy_instance === VOID)
    new (Incident_readBy())();
  return Incident_readBy_instance;
}
function Incident_concern$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(6);
}
function Incident_concern$_get_name_$ref_anp08w() {
  return (p0) => p0.i20();
}
function Incident_concern$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[6];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function Incident_concern$_get_serializer_$ref_67pdwn() {
  return (p0) => p0.h2j();
}
function Incident_concern$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(6);
}
function Incident_concern$_get_annotations_$ref_4cs4az() {
  return (p0) => p0.bz();
}
var Incident_concernClass;
function Incident_concern() {
  if (Incident_concernClass === VOID) {
    class $ {
      constructor() {
        Incident_concern_instance = this;
        var tmp = this;
        tmp.u64_1 = lazy(Incident_concern$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.v64_1 = lazy(Incident_concern$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.w64_1 = lazy(Incident_concern$annotations$delegate$lambda);
        this.x64_1 = ClientConcern_Other_getInstance();
        this.y64_1 = 'ClientConcern.Other';
      }
      i20() {
        var tmp0 = this.u64_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, Incident_concern$_get_name_$ref_anp08w(), null);
        return tmp0.f2();
      }
      a63(receiver) {
        return receiver.h63_1;
      }
      k2j(receiver) {
        return this.a63(receiver instanceof Incident() ? receiver : THROW_CCE());
      }
      z64(receiver, value) {
        return receiver.m63(VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof Incident() ? receiver : THROW_CCE();
        return this.z64(tmp, value instanceof ClientConcern() ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.v64_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, Incident_concern$_get_serializer_$ref_67pdwn(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.w64_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, Incident_concern$_get_annotations_$ref_4cs4az(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'Incident_concern', VOID, VOID, [SerializableProperty()]);
    Incident_concernClass = $;
  }
  return Incident_concernClass;
}
var Incident_concern_instance;
function Incident_concern_getInstance() {
  if (Incident_concern_instance === VOID)
    new (Incident_concern())();
  return Incident_concern_instance;
}
function Incident_canFileDispute$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(8);
}
function Incident_canFileDispute$_get_name_$ref_b6pkpe() {
  return (p0) => p0.i20();
}
function Incident_canFileDispute$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[8];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function Incident_canFileDispute$_get_serializer_$ref_5rxi6f() {
  return (p0) => p0.h2j();
}
function Incident_canFileDispute$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(8);
}
function Incident_canFileDispute$_get_annotations_$ref_kvxh25() {
  return (p0) => p0.bz();
}
var Incident_canFileDisputeClass;
function Incident_canFileDispute() {
  if (Incident_canFileDisputeClass === VOID) {
    class $ {
      constructor() {
        Incident_canFileDispute_instance = this;
        var tmp = this;
        tmp.a65_1 = lazy(Incident_canFileDispute$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.b65_1 = lazy(Incident_canFileDispute$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.c65_1 = lazy(Incident_canFileDispute$annotations$delegate$lambda);
        this.d65_1 = false;
        this.e65_1 = 'false';
      }
      i20() {
        var tmp0 = this.a65_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, Incident_canFileDispute$_get_name_$ref_b6pkpe(), null);
        return tmp0.f2();
      }
      a63(receiver) {
        return receiver.j63_1;
      }
      k2j(receiver) {
        return this.a63(receiver instanceof Incident() ? receiver : THROW_CCE());
      }
      f65(receiver, value) {
        return receiver.m63(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof Incident() ? receiver : THROW_CCE();
        return this.f65(tmp, (!(value == null) ? typeof value === 'boolean' : false) ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.b65_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, Incident_canFileDispute$_get_serializer_$ref_5rxi6f(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.c65_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, Incident_canFileDispute$_get_annotations_$ref_kvxh25(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'Incident_canFileDispute', VOID, VOID, [SerializableProperty()]);
    Incident_canFileDisputeClass = $;
  }
  return Incident_canFileDisputeClass;
}
var Incident_canFileDispute_instance;
function Incident_canFileDispute_getInstance() {
  if (Incident_canFileDispute_instance === VOID)
    new (Incident_canFileDispute())();
  return Incident_canFileDispute_instance;
}
function Incident_canLockProject$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(9);
}
function Incident_canLockProject$_get_name_$ref_hydfvc() {
  return (p0) => p0.i20();
}
function Incident_canLockProject$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[9];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function Incident_canLockProject$_get_serializer_$ref_6bg2td() {
  return (p0) => p0.h2j();
}
function Incident_canLockProject$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(9);
}
function Incident_canLockProject$_get_annotations_$ref_xc6t5p() {
  return (p0) => p0.bz();
}
var Incident_canLockProjectClass;
function Incident_canLockProject() {
  if (Incident_canLockProjectClass === VOID) {
    class $ {
      constructor() {
        Incident_canLockProject_instance = this;
        var tmp = this;
        tmp.g65_1 = lazy(Incident_canLockProject$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.h65_1 = lazy(Incident_canLockProject$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.i65_1 = lazy(Incident_canLockProject$annotations$delegate$lambda);
        this.j65_1 = false;
        this.k65_1 = 'false';
      }
      i20() {
        var tmp0 = this.g65_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, Incident_canLockProject$_get_name_$ref_hydfvc(), null);
        return tmp0.f2();
      }
      a63(receiver) {
        return receiver.k63_1;
      }
      k2j(receiver) {
        return this.a63(receiver instanceof Incident() ? receiver : THROW_CCE());
      }
      f65(receiver, value) {
        return receiver.m63(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof Incident() ? receiver : THROW_CCE();
        return this.f65(tmp, (!(value == null) ? typeof value === 'boolean' : false) ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.h65_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, Incident_canLockProject$_get_serializer_$ref_6bg2td(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.i65_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, Incident_canLockProject$_get_annotations_$ref_xc6t5p(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'Incident_canLockProject', VOID, VOID, [SerializableProperty()]);
    Incident_canLockProjectClass = $;
  }
  return Incident_canLockProjectClass;
}
var Incident_canLockProject_instance;
function Incident_canLockProject_getInstance() {
  if (Incident_canLockProject_instance === VOID)
    new (Incident_canLockProject())();
  return Incident_canLockProject_instance;
}
//region block: exports
export {
  prepareIncidentFields as prepareIncidentFields12s4axzaywy4c,
  get_project as get_projectzxws9pkspb0a,
  get_state as get_state333q9k6vwmx2f,
};
//endregion

//# sourceMappingURL=IncidentFields.mjs.map
